var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagnifying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1858 26.2093L23.7872 29.8107L13.4333 40.1646L9.83183 36.5632L20.1858 26.2093Z",
    fill: "#8D9CA8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26819 48.7319C-0.42273 47.0409 -0.42273 44.2994 1.26819 42.6085L12.8546 31.0221C13.4846 30.3921 14.5059 30.3921 15.1359 31.0221L18.978 34.8642C19.6079 35.4942 19.6079 36.5154 18.978 37.1454L7.39163 48.7319C5.70071 50.4228 2.95911 50.4228 1.26819 48.7319Z",
    fill: "#FE646F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5939 34.8123C42.2071 34.8123 50.0001 27.0193 50.0001 17.4062C50.0001 7.793 42.2071 0 32.5939 0C22.9807 0 15.1877 7.793 15.1877 17.4062C15.1877 27.0193 22.9807 34.8123 32.5939 34.8123Z",
    fill: "#9FACBA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5939 29.8716C39.4783 29.8716 45.0593 24.2906 45.0593 17.4061C45.0593 10.5217 39.4783 4.9407 32.5939 4.9407C25.7094 4.9407 20.1284 10.5217 20.1284 17.4061C20.1284 24.2906 25.7094 29.8716 32.5939 29.8716Z",
    fill: "#D8ECFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9018 5.09813C44.4946 4.69091 44.0719 4.30878 43.6362 3.95038C49.2609 10.7879 48.8788 20.9104 42.4885 27.3008C36.0981 33.6911 25.9757 34.0732 19.1381 28.4485C19.4965 28.8843 19.8786 29.3069 20.2858 29.7142C27.0834 36.5117 38.1043 36.5117 44.9018 29.7142C51.6994 22.9166 51.6994 11.8956 44.9018 5.09813Z",
    fill: "#8D9CA8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.978 34.8642L16.5646 32.4508C17.1946 33.0808 17.1946 34.1021 16.5646 34.7321L4.9783 46.3185C3.7159 47.5809 1.86814 47.9003 0.30896 47.2778C0.520288 47.8071 0.839722 48.3033 1.26834 48.7318C2.95925 50.4227 5.70076 50.4227 7.39168 48.7318L18.9781 37.1453C19.608 36.5155 19.608 35.4942 18.978 34.8642Z",
    fill: "#FD4755"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4083 8.59169C41.0774 8.26083 40.7321 7.95341 40.375 7.66757C44.2879 12.5574 43.9804 19.7336 39.4509 24.2631C34.9215 28.7925 27.7452 29.1 22.8553 25.1872C23.1411 25.5443 23.4486 25.8897 23.7795 26.2205C28.6397 31.0808 36.548 31.0808 41.4083 26.2205C46.2685 21.3603 46.2685 13.452 41.4083 8.59169Z",
    fill: "#C4E2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifying);
export default __webpack_public_path__ + "static/media/icon_magnifying.7278b516de8adead5650814d0f308862.svg";
export { ForwardRef as ReactComponent };